import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'serie-a';
const { variant, uniform, localOnly } = leagueBuilder(ID);

const teams = [
  team('monza', 'Monza', uniform('monza', '#ED1639', LIGHT)),
  team('atalanta', 'Atalanta', uniform('atalanta', '#0068B5', '#FFFFFF')),
  team('bologna', 'Bologna', uniform('bologna', '#BA1930', '#0B2336')),
  team('cagliari', 'Cagliari', uniform('cagliari', '#CE0824', '#001C41')),
  team('catanzaro', 'Catanzaro', uniform('catanzaro', '#FF130B', '#FFF300')),
  team('como', 'Como', [localOnly('#114169', 'como'), variant(LIGHT, 'como')]),
  team('fiorentina', 'Fiorentina', uniform('fiorentina', '#652F90', LIGHT)),
  team('frosinone', 'Frosinone', [variant(['#004393', '#FFDD00'], 'frosinone')]),
  team('genoa', 'Genoa', uniform('genoa', '#CC1212', '#00213D')),
  team('hellas-verona', 'Hellas Verona', [variant(['#002E70', '#FFD200'], 'hellas-verona')]),
  team('inter', 'Inter', uniform('inter', '#001DA0', LIGHT)),
  team('juventus', 'Juventus', [localOnly('#000000', 'juventus'), variant(LIGHT, 'juventus')]),
  team('lazio', 'Lazio', uniform('lazio', '#95D3F2', LIGHT)),
  team('lecce', 'Lecce', uniform('lecce', '#00204F', LIGHT)),
  team('milan', 'Milan', uniform('milan', '#FF151F', '#000000')),
  team('napoli', 'Napoli', [localOnly('#00A8E4', 'napoli'), variant(LIGHT, 'napoli')]),
  team('parma', 'Parma', uniform('parma', '#1D3689', '#FFD300')),
  team('pisa', 'Pisa', uniform('pisa', '#0073B8', '#000000')),
  team('roma', 'Roma', uniform('roma', '#B30328', '#FFBB00')),
  team('sassuolo', 'Sassuolo', uniform('sassuolo', '#00B854', '#000000')),
  team('torino', 'Torino', uniform('torino', ['#7A2F34', '#7A2F32'], LIGHT)),
  team('udinese', 'Udinese', uniform('udinese', '#352D29', '#B3B4B7')),
  team('cremonese', 'Cremonese', uniform('cremonese', '#DF0009', '#000000')),
  team('venezia', 'Venezia', [variant(['#AA8E52', '#151713'], 'venezia')])
];

export const serieA: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(37, 46, 248, 385) },
  teams
};
